<template>
  <div v-if="show" class="mt-8">
    <!-- <tableSearch
      @search="search = $event"
      :placeholder="
        $t('SEARCH_FOR', { type: $t('FULL_NAME') + ' ' + $t('DRIVER_TITLE') })
      "
    /> -->
    <titleHolder :title="$t('HISTORY_ROUTES')" />
    <el-table
      :empty-text="$t('NO_DATA')"
      row-class-name="notSticky"
      :data="
        tableData.filter(
          (data) =>
            !search ||
            (data.driver &&
              (data.driver.first_name.includes(search) ||
                data.driver.last_name.includes(search)))
        )
      "
      v-loading="loading"
      :stripe="true"
      style="width: 100%"
    >
      <el-table-column
        sortable
        type="index"
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        :label="$t('INDEX')"
        width="60"
      >
        <template slot-scope="scope">
          <div :data-title="$t('INDEX')">
            {{ scope.$index + 1 }}
          </div>
        </template>
      </el-table-column>
      <!-- <el-table-column :align="$i18n.locale == 'fa' ? 'right' : 'left'" :label="$t('FULL_NAME')" width="100"> -->
      <!-- <template slot-scope="scope">
          <div :data-title="$t('FULL_NAME')">
            <span v-if="scope.row.driver">
              {{
                scope.row.driver.first_name + " " + scope.row.driver.last_name
              }}
            </span>
            <span v-else class="text-gray-400"> {{ $t("NO_DRIVER") }} </span>
          </div>
        </template>
      </el-table-column> -->
      <!-- <el-table-column :align="$i18n.locale == 'fa' ? 'right' : 'left'" :label="$t('VEHICLE_TITLE')" width="120">
        <template slot-scope="scope">
          <LicensePlate v-if="scope.row.company_vehicle != null" :vehicle="scope.row.company_vehicle.vehicle"
            :license_plate="scope.row.company_vehicle.license_plate" :chars="alpha">
          </LicensePlate>
          <span v-else class="text-gray-400"> {{ $t("NO_VEHICLE") }} </span>
        </template>
      </el-table-column> -->

      <el-table-column
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        :label="`${$t('DURATION')} (${$t('HOUR')})`"
        width="100"
      >
        <template slot-scope="scope">
          <div :data-title="`${$t('DURATION')} (${$t('HOUR')})`">
            {{ calculateHour(scope.row.duration) }}
          </div>
        </template>
      </el-table-column>

      <!-- <el-table-column :align="$i18n.locale == 'fa' ? 'right' : 'left'" :label="$t('ODOMETER')" width="100">
        <template slot-scope="scope">
          <div :data-title="$t('ODOMETER')">
            {{ scope.row.odometer / 1000 }}
          </div>
        </template>
      </el-table-column> -->

      <el-table-column
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        width="150"
      >
        <template slot-scope="scope">
          <div
            :data-title="$t('TIME')"
            class="flex flex-col justify-end lg:justify-center"
          >
            <p class="flex items-start">
              <span class="text-gray-500 text-xs ml-2">
                {{ $t('START_TIME') }}:
              </span>
              <span
                >{{
                  new Date(scope.row.start_datetime).toLocaleTimeString('fa-IR')
                }}
                |
                {{
                  new Date(scope.row.start_datetime).toLocaleDateString('fa-IR')
                }}</span
              >
            </p>
            <p class="flex items-start">
              <span class="text-gray-500 text-xs ml-2">
                {{ $t('END_TIME') }}:
              </span>
              <span
                >{{
                  new Date(scope.row.stop_datetime).toLocaleTimeString('fa-IR')
                }}
                |
                {{
                  new Date(scope.row.stop_datetime).toLocaleDateString('fa-IR')
                }}</span
              >
            </p>
          </div>
        </template>
      </el-table-column>

      <el-table-column width="100" type="expand" :label="$t('MORE_INFO')">
        <template slot-scope="props">
          <div
            class="
              grid grid-cols-1
              md:grid-cols-2
              lg:grid-cols-4
              gap-6
              md:gap-4
            "
          >
            <!-- <Field :title="$t('IMEI')" type="col" align="start">
              {{ props.row.device.imei }}
            </Field> -->

            <!-- <Field type="col" align="start">
              <div
                class="flex flex-col justify-end lg:justify-center space-y-2"
              >
                <p class="flex items-start">
                  <span class="text-gray-500 text-xs ml-2">
                    {{ $t("START_TIME") }}:
                  </span>
                  <span
                    >{{
                      new Date(props.row.start_datetime).toLocaleTimeString("fa-IR")
                    }}
                    |
                    {{
                      new Date(props.row.start_datetime).toLocaleDateString("fa-IR")
                    }}</span
                  >
                </p>
                <p class="flex items-start">
                  <span class="text-gray-500 text-xs ml-2">
                    {{ $t("END_TIME") }}:
                  </span>
                  <span
                    >{{ new Date(props.row.stop_datetime).toLocaleTimeString("fa-IR") }}
                    |
                    {{
                      new Date(props.row.stop_datetime).toLocaleDateString("fa-IR")
                    }}</span
                  >
                </p>
              </div>
            </Field> -->

            <Field :title="$t('MAX_SPEED')" type="col" align="start">
              {{ props.row.max_speed }}
              <span class="mx-1 text-xs text-gray-500 font-light">
                ({{ $t('KM_H') }})
              </span>
            </Field>
            <Field :title="$t('AVG_SPEED')" type="col" align="start">
              {{ props.row.mean_speed }}
              <span class="mx-1 text-xs text-gray-500 font-light">
                ({{ $t('KM_H') }})
              </span>
            </Field>
            <div
              class="flex flex-col lg:col-span-2 gap-2"
              :class="{ 'lg:col-start-3': $i18n.locale == 'fa' }"
            >
              <h3 class="text-xs text-gray-500 ml-2">
                {{ $t('Abnormal_behaviors') }}
              </h3>
              <VueApexCharts
                type="bar"
                height="200"
                :options="chartOptions"
                :series="test(props.row)"
              ></VueApexCharts>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="" width="50">
        <template slot-scope="scope">
          <el-tooltip
            class="item"
            effect="dark"
            :content="$t('VIEW')"
            placement="bottom"
          >
            <i
              class="el-icon-view text-xl cursor-pointer text-purple-700"
              :class="{
                'ml-3': $i18n.locale == 'fa',
                'mr-3': $i18n.locale != 'fa',
              }"
              @click="senReq(scope.row)"
            ></i> </el-tooltip
        ></template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
// import tableSearch from '@/components/elements/tableSearch'
import LicensePlate from '@/components/cars/LicensePlate'
import { calculateHour } from '@/mixins/calculateHour'
import Field from '@/components/elements/field'
import VueApexCharts from 'vue-apexcharts'
import { view } from '@/mixins/viewPage'
import titleHolder from '@/components/elements/title.vue'
import { trips } from '@/api/reports'

export default {
  props: ['tableData', 'vehicleId'],
  mixins: [view, calculateHour],
  components: {
    // tableSearch,
    titleHolder,
    LicensePlate,
    Field,
    VueApexCharts,
  },
  data() {
    return {
      search: '',
      show: false,
      tripData: this.tableData,
      chartOptions: {
        chart: {
          type: 'bar',
          height: 350,
          stacked: false,
        },
        plotOptions: {
          bar: {
            horizontal: true,
            borderRadius: 4,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          width: 1,
          colors: ['#fff'],
        },

        xaxis: {
          categories: [' ', ' ', ' ', ' '],
        },
        yaxis: {
          title: {
            text: undefined,
          },
        },
        tooltip: {},
        fill: {
          opacity: 1,
        },
        legend: {
          position: 'top',
          horizontalAlign: 'left',
          offsetX: 40,
        },
      },
      lastData: null,
      loading: false,
    }
  },
  watch: {
    tableData(val) {
      if (val && val.length > 0) this.show = true
    },
  },
  methods: {
    test(props) {
      let series = [
        {
          name: this.$t('acceleration'),
          data: [props.harsh_acceleration_count],
        },
        {
          name: this.$t('braking'),
          data: [props.harsh_braking_count],
        },
        {
          name: this.$t('cornering'),
          data: [props.harsh_cornering_count],
        },
        // {
        //   name: this.$t('UNSUAL_SPEED'),
        //   data: [props.number_of_overspeedings],
        // },
      ]
      return series
    },
    senReq(row) {
      const actionPayload = [
        this.vehicleId,
        Date.parse(row.start_datetime) / 1000,
        Date.parse(row.stop_datetime) / 1000,
      ]
      this.loading = true
      this.$emit('path', null)
      trips.api(actionPayload).then((res) => {
        this.loading = false

        if (res && res.points.length > 0) {
          if (this.lastData != null) {
            this.$emit('realtime', true)
          }
          this.lastData = res
          this.$emit('path', res)
        } else {
          this.$notify.error({
            title: this.$i18n.t('NO_DATA_FOR_VEHICLE'),
            duration: 5000,
            customClass: 'error_msg',
          })
        }
      })
    },
  },
}
</script>
